export default __webpack_public_path__ + "static/media/acessibilidade-contrast.a48dc18a.png";